export function getWarningImage(status: 0 | 1 | 2): string {
  if (status === 1) return "/images/icons/ic_common_warning02.png";
  if (status === 2) return "/images/icons/ic_common_warning01.png";
  return "";
}
